/**
 * Applies selected state styling to a theme object
 * @param {Object} theme - The base theme object
 * @param {boolean} isSelected - Whether the node is selected
 * @returns {Object} Theme object with selected styling applied if needed
 */
export const applySelectedTheme = (theme, isSelected) => {
  if (!isSelected || !theme) {
    return theme;
  }

  // Override the light color to primaryLight for blue highlight when selected
  return {
    ...theme,
    light: "primaryLight",
  };
};
